import { render, staticRenderFns } from "./vertical_expander.vue?vue&type=template&id=b7ce911c&"
import script from "./vertical_expander.vue?vue&type=script&lang=js&"
export * from "./vertical_expander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports